export enum SERIES_IDS {
  forecast = 'forecast',
  linkedForecast = 'linked-forecast',
  measurement = 'measurement',
  linkedMeasurement = 'linked-measurement',
  quality = 'quality',
  linkedQuality = 'linked-quality',
  spotPrice = 'spotPrice',
}
